import React from 'react';
import PropTypes from 'prop-types';

// Ряд статус-пилюль игры (.fr-st) для head-card. Клик меняет статус.
// Общий компонент для всех игр: статус вынесен в шапку.
export default function StatusRow({ statuses, current, onChange }) {
    return (
        <>
            {statuses.map(status => (
                <button
                    type="button"
                    key={status.value}
                    data-fst={status.tone}
                    className={`fr-st${status.value === current ? ' on' : ''}`}
                    onClick={() => onChange(status.value)}
                >
                    {status.label}
                </button>
            ))}
        </>
    );
}

StatusRow.propTypes = {
    statuses: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        tone: PropTypes.oneOf(['dev', 'wait', 'active', 'done']).isRequired
    })).isRequired,
    current: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

StatusRow.defaultProps = { current: null };
